"use client";

import { useState, useEffect, useMemo } from "react";
import type { Params } from "next/dist/server/request/params";
import { useParams } from "next/navigation";
import cn from "@/utils/cn";
import { weapons, killfeed, wipes } from "..";
export default function WeaponsTable({
  params
}: {
  params: Params;
}) {
  params = useParams() ?? params;
  const wipeIndex = Number(params.wipeId) - 1;
  const [data, setData] = useState(() => weapons[wipeIndex]);
  useEffect(() => {
    params?.wipeId && setData(weapons[wipeIndex]);
  }, [wipeIndex]);
  const ignoredWeaponIds = useMemo(() => wipes[wipeIndex].ignoredWeapons.map(weaponName => killfeed.weaponNames.indexOf(weaponName)), [wipeIndex]);
  return <div>
            <div className="rounded overflow-hidden border">
                <table className="min-w-xs">
                    <thead>
                        <tr className="border-b-3 bg-neutral-900 h-10">
                            <th className="p-1.5 text-left">Weapon</th>
                            <th className="p-1.5 text-right">Kills</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(weapon => <tr key={weapon.id} className="hover:bg-neutral-900/50 border-t">
                                <td className={cn("p-1.5", ignoredWeaponIds.includes(weapon.id) && "bg-rose-900")}>{killfeed.weaponNames[weapon.id]}</td>
                                <td className="p-1.5 text-right">{weapon.kills}</td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>;
}